export default {
  LIST (state, value) {
    state.list = (value && Array.isArray(value)) ? [...value] : []
  }
}
